export const IMAGE_TO_VIDEO_POLL_ID =
  'app/image-to-video/image-to-video-poll-id';
